import { render, staticRenderFns } from "./detailsPickupTruck.vue?vue&type=template&id=14496184&scoped=true&"
import script from "./detailsPickupTruck.vue?vue&type=script&lang=js&"
export * from "./detailsPickupTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14496184",
  null
  
)

export default component.exports